<!-- Grid View -->
<div class="card coupon-grid-outer" (click)="showCouponPreviewModal(couponData, coupon_preview_modal)" *ngIf="displayType == 'grid'">
  <div class="card-body text-center cursor-pointer">
    <div class="row">
      <div class="col-12">
        <span class="float-start" *ngIf="couponData?.status == 2">
          <i-bs class="text-warning" name="clockHistory" title="In Review"></i-bs>
          <span class="status text-muted">&nbsp;In Review</span>
        </span>
        <span class="float-start" *ngIf="couponData?.status == 3">
          <i-bs class="text-secondary" name="check2Circle" title="Approved"></i-bs>
          <span class="status text-muted">&nbsp;Approved</span>
        </span>
        <span class="float-start" *ngIf="couponData?.status == 4">
          <i-bs class="text-danger" name="xCircle" title="Rejected"></i-bs>
          <span class="status text-muted">&nbsp;Rejected</span>
        </span>

        <span class="float-end" *ngIf="module == 'RETAILER' && couponData?.status == 2">
          <button type="button" class="btn btn-outline-warning btn-sm">Review</button>
        </span>
      </div>
    </div>

    <h5 class="text-danger" *ngIf="couponData?.coupon_discount.discount_id == 1 && couponData?.coupon_discount.dollar_discount_compare == 0">Save ${{ couponData?.coupon_discount.discount_lower }}</h5>
    
    <h5 class="text-danger" *ngIf="couponData?.coupon_discount.discount_id == 1 && couponData?.coupon_discount.dollar_discount_compare == 1">
      <span style="text-decoration: line-through; color: grey;">${{ couponData?.coupon_discount.discount_lower }}</span>
      ${{ couponData?.coupon_discount.discount_upper }}
    </h5>
    
    <h5 class="text-danger" *ngIf="couponData?.coupon_discount.discount_id == 2">Save {{ couponData?.coupon_discount.discount_lower }}%</h5>
    
    <h5 class="text-danger" *ngIf="couponData?.coupon_discount.discount_id == 3">Buy {{ couponData?.coupon_discount.discount_lower }} Get {{ couponData?.coupon_discount.discount_upper }}</h5>

    <div class="title text-muted mt-1 mb-2" [title]="couponData.coupon_title">{{ couponData.coupon_title }}</div>

    <img class="img mt-1 mb-2" [src]="couponData.coupon_image" alt="...">

    <div class="row">
      <div class="col-12">
        <span class="coupon-date text-muted float-start pt-1">
          <i-bs class="text-info" name="calendarCheck" title="Coupon Date"></i-bs>
          {{ couponData.start_date | date : 'MMM d, y' : 'UTC' }} - {{ couponData.coupon_expiration.date | date : 'MMM d, y' : 'UTC' }}
        </span>

        <span class="float-end" [ngbPopover]="couponPopContent" triggers="mouseenter" (mouseleave)="p.close()" #p="ngbPopover">
          <i-bs class="text-info cursor-pointer" name="infoCircle"></i-bs>
          <span class="status text-muted">&nbsp;Details</span>
        </span>
      </div>
    </div>
  </div>
</div>

<!-- List View -->
<div class="coupon-list-outer bg-white" *ngIf="displayType == 'list'">
  <!-- Header -->
  <div class="row header-row border-bottom m-1 pt-4">
    <div class="col-1 title text-muted">Image</div>
    <div class="col-3 title text-muted">Title</div>
    <div class="col-3 title text-muted">Type</div>
    <div class="col-2 title text-muted">Start Date</div>
    <div class="col-2 title text-muted">End Date</div>
    <div class="col-1 title text-muted">Status</div>
  </div>

  <!-- Data -->
  <div class="row data-row border-bottom border-light m-1 cursor-pointer" *ngFor="let coupon of couponListData" (click)="showCouponPreviewModal(coupon, coupon_preview_modal)">
    <div class="col-1">
      <img class="img" [src]="coupon.coupon_image" alt="...">
    </div>
    <div class="col-3 value text-muted">
      {{ coupon.coupon_title }}
    </div>
    <div class="col-3 value text-muted">
      <span *ngIf="coupon?.coupon_discount.discount_id == 1 && coupon?.coupon_discount.dollar_discount_compare == 0">Save ${{ coupon?.coupon_discount.discount_lower }}</span>
      <span *ngIf="coupon?.coupon_discount.discount_id == 1 && coupon?.coupon_discount.dollar_discount_compare == 1">
        <span style="text-decoration: line-through;">${{ coupon?.coupon_discount.discount_lower }}</span>
        ${{ coupon?.coupon_discount.discount_upper }}
      </span>
      <span *ngIf="coupon?.coupon_discount.discount_id == 2">Save {{ coupon?.coupon_discount.discount_lower }}%</span>
      <span *ngIf="coupon?.coupon_discount.discount_id == 3">Buy {{ coupon?.coupon_discount.discount_lower }} Get {{ coupon?.coupon_discount.discount_upper }}</span>
    </div>
    <div class="col-2 value text-muted">
      {{ coupon.start_date | date : 'MMM d, y' : 'UTC' }}
    </div>
    <div class="col-2 value text-muted">
      {{ coupon.coupon_expiration.date | date : 'MMM d, y' : 'UTC' }}
    </div>
    <div class="col-1 value">
      <span class="text-warning" *ngIf="coupon?.status == 2">In Review</span>
      <span class="text-muted" *ngIf="coupon?.status == 3">Approved</span>
      <span class="text-danger" *ngIf="coupon?.status == 4">Rejected</span>
    </div>
  </div>
</div>

<!-- Coupon Details Popover-->
<ng-template #couponPopContent>
  <div class="container popover-outer p-0">
    <div class="row">
      <div class="col-12">
        <div class="text-muted fw-bold">Quantity per Transaction : <span class="qty-per-transaction text-muted fw-normal">{{ couponData.max_redeem_quantity }}</span></div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="text-muted fw-bold">Max Redemptions : <span class="max-redemptions text-muted fw-normal">{{ couponData.coupon_expiration.counter }}</span></div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="text-muted fw-bold">Products ({{ couponData.products.length }})</div>
        <div *ngFor="let product of couponData.products; let i = index;">
          <span class="products text-muted">{{ product.item_name }} ({{ product.upc }})<span *ngIf="i < couponData.products.length-1">,</span> </span>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="text-muted fw-bold">Terms</div>

        <div class="terms text-muted">{{ couponData.terms }}</div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Coupon Preview Modal -->
<ng-template #coupon_preview_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ couponPreviewModalData.coupon_title }}</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCouponPreviewModal()"></i-bs>
  </div>

  <div class="modal-body">
    <app-preview-coupon module="SHARED" page="show-coupon" [couponPreviewData]="couponPreviewModalData"></app-preview-coupon>
  </div>

  <div class="modal-footer" *ngIf="module == 'RETAILER' && couponPreviewModalData?.status == 2">
    <button type="button" class="btn btn-danger text-white fw-bold" title="Reject Coupon" [disabled]="reviewing" (click)="onReview('false')">
      <i-bs class="text-light" name="xCircle"></i-bs>
      <span>&nbsp;Reject</span>
    </button>

    <button type="button" class="btn btn-secondary text-white fw-bold" title="Accept Coupon" [disabled]="reviewing" (click)="onReview('true')">
      <i-bs class="text-light" name="checkCircle"></i-bs>
      <span>&nbsp;Accept</span>
    </button>

    <div class="spinner-border spinner-border-sm text-primary" role="status" *ngIf="reviewing"></div>
  </div>
</ng-template>
